module.exports = __webpack_public_path__ + "img/exhibition-1.94206f63.png";